import { useEffect } from 'react';

import { CHUNK_RELOAD_KEY } from '@/shared/lib/lazyWithRetry';

/**
 * Хук для обработки ошибок загрузки динамических модулей Vite.
 *
 * При первом срабатывании подавляет ошибку через preventDefault()
 * и перезагружает страницу. Если после перезагрузки ошибка повторяется —
 * пропускает её дальше (в Sentry) для диагностики.
 */
export const useVitePreloadError = () => {
  useEffect(() => {
    /**
     * Обработчик ошибки предзагрузки модуля Vite
     */
    const handlePreloadError = () => {
      if (!sessionStorage.getItem(CHUNK_RELOAD_KEY)) {
        sessionStorage.setItem(CHUNK_RELOAD_KEY, 'true');
        window.location.reload();
      }
    };

    if (import.meta.env.PROD) {
      window.addEventListener('vite:preloadError', handlePreloadError);
    }

    return () => {
      window.removeEventListener('vite:preloadError', handlePreloadError);
    };
  }, []);
};
